module.exports = __webpack_public_path__ + "img/20210314_120206.0594626f.jpg";